import styled from 'styled-components';

export const ValueViewPrimitive = styled.div`
  display: inline-block;
  padding: 0 4px;
  background-color: light-dark(var(--moon-150), var(--moon-800));
  border-radius: 4px;
  font-weight: 600;
  font-family: monospace;
  font-size: 10px;
  line-height: 20px;
`;
ValueViewPrimitive.displayName = 'S.ValueViewPrimitive';
